import PropTypes from "prop-types";

const GroupComponent = ({ className = "", separator, sacombank }) => {
  return (
    <div
      className={`self-stretch rounded-xl bg-light-primary-key-background flex flex-col items-start justify-start pt-7 pb-[25px] pl-[29px] pr-[19px] box-border gap-[33px] max-w-full z-[5] text-left text-base text-dark-text font-text-regular-lowercase mq360:gap-4 ${className}`}
    >
      <div className="w-[360px] h-40 relative rounded-xl bg-light-primary-key-background hidden max-w-full" />
      <div className="flex flex-col items-start justify-start gap-2.5">
        <div className="relative z-[1]">Người Việt Nam</div>
        <div className="relative text-light-text z-[1]">{separator}</div>
      </div>
      <div className="self-stretch flex flex-row items-start justify-between gap-5">
        <div className="flex flex-col items-start justify-start pt-1 px-0 pb-0">
          <div className="relative z-[1]">{sacombank}</div>
        </div>
        <img
          className="h-6 w-6 relative overflow-hidden shrink-0 z-[1]"
          loading="lazy"
          alt=""
          src="/mode-edit-outline.svg"
        />
      </div>
    </div>
  );
};

GroupComponent.propTypes = {
  className: PropTypes.string,
  separator: PropTypes.string,
  sacombank: PropTypes.string,
};

export default GroupComponent;
